(function () {
    'use strict';

    angular.module('app')
        .factory('DataFactory', DataFactory);

    /* @ngInject */
    function DataFactory($http, Papa) {

        var basePath = '/data/';

        return {
            getData: getData,
			getJSON: getJSON,
			getFilterOptions: getFilterOptions,
			generateSampleChartData: generateSampleChartData,
			getSamplesString: getSamplesString,
			hasLowSampleSize: hasLowSampleSize,
			getTableData: getTableData,
			injectSampleInfo: injectSampleInfo,
        };

        function getJSON(file) {

            console.log('getting', file);

            var fullPath = basePath + file + '.json';

            return $http.get(fullPath, {cache: true}).then(function success(response) {
                return angular.fromJson(response.data);
            }, function failure() {
                console.log('Failed to get data at', fullPath);
            });
        }

        function getData(file, isMultiSeries) {

            console.log('getting', file);

            isMultiSeries = !!isMultiSeries;

            var fullPath = basePath + file + '.csv';

            return $http.get(fullPath, {cache: true}).then(function success(response) {

                var data;

                Papa.parse(response.data, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function (results) {
                        data = isMultiSeries ? processMultiSeriesData(results) : processData(results);
                    },
                    error: function(error) {
                        console.log('CSV error:', error);
                    }
                });

                return data;
            }, function failure() {
                console.log('Failed to get data at', fullPath);
            });
        }
		
		function getTableData(key) {
            console.log('getting table data', key);

            var fullPath = basePath + key + '.csv';

            return $http.get(fullPath, {cache: true}).then(function success(response) {
                var data;

                Papa.parse(response.data, {
                    header: false,
                    skipEmptyLines: true,
                    complete: function (results) {
                        data = processTableData(results);
                    },
                    error: function(error) {
                        console.log('CSV error:', error);
                    }
                });

                return data;
            }, function failure() {
                console.log('Failed to get table data at', fullPath);
            });
		}
		
		function processTableData(papaData) {
			var out = {
				columns: [],
				rows: [],
				// raw: papaData,
			};
			
			function isSectionRow(row) {
				if (!angular.isDefined(row) || !angular.isArray(row) || row.length == 0) return false;
				if (String(row[0]).trim() === '') return false;
				var result = true;
				for (var i = 1; i < row.length; i++) {
					if (angular.isString(row[i]) && row[i].trim().length > 0) {
						result = false;
					}
				}
				return result;
			}
			
			function isTotalRow(row) {
				if (!angular.isDefined(row) || !angular.isArray(row) || row.length == 0) return false;
				return String(row[0]).trim().toUpperCase() === 'TOTAL';
			}
			
			if (papaData.data.length > 0) {
				angular.forEach(papaData.data[0], function(header){
					out.columns.push(header.replace('\n', '<br/>'));
				});
			}
			
			if (papaData.data.length > 1) {
				for (var rIdx = 1; rIdx < papaData.data.length; rIdx++) {
					var row = papaData.data[rIdx];
					if (isSectionRow(row)) {
						out.rows.push({ type: 'SECTION', values: row });
					} else if (isTotalRow(row)) {
						out.rows.push({ type: 'TOTAL', values: row });
					} else {
						out.rows.push({ type: 'DATA', values: row });
					}
				}
			}
			
			return out;
		}

        function processMultiSeriesData(csv) {

            var out = [],
                tmp = {},
                cols = [],
                survey = '',
                series = '',
                category = '',
                value = '',
                values = [];

            if (csv.meta.fields.length < 4) {
                console.log('Not enough fields');
            }

            angular.forEach(csv.data, function (row) {

                survey = row[csv.meta.fields[0]].trim();
                series = row[csv.meta.fields[1]].trim();
                category = row[csv.meta.fields[2]].trim();
                values = [];

                if (survey === '' || series === '' || category === '') {
                    return;
                }

                for (var i = 3; i < csv.meta.fields.length; i++) {
                    values.push(row[csv.meta.fields[i]].trim());
                }

                if (angular.isUndefined(tmp[survey])) {
                    tmp[survey] = {};
                }

                if (angular.isUndefined(tmp[survey][series])) {
                    tmp[survey][series] = [];
                }

                tmp[survey][series].push({
                    category: category,
                    values: values
                });
            });

            // Aggregate the series
            angular.forEach(tmp, function(data, survey) {

                var series1 = Object.keys(tmp[survey])[0];

                out[survey] = [];

                angular.forEach(tmp[survey][series1], function (x, i) {

                    var dataRow = {
                        Category: x.category,
                        AdditionalData: {}
                    };

                    angular.forEach(tmp[survey], function (vals, seriesName) {
                        dataRow[seriesName] = vals[i].values[0];
                        dataRow.AdditionalData[seriesName] = [];

                        for (var j = 1; j < vals[i].values.length; j++) {
                            dataRow.AdditionalData[seriesName].push(vals[i].values[j]);
                        }
                    });

                    out[survey].push(dataRow);
                });
            });

            return out;
        }

        function processData(csv) {

            var out = [],
                cols = [],
                survey = '',
                category = '',
                value = '';

            if (csv.meta.fields.length < 3) {
                console.log('Not enough fields');
                return out;
            }

            // Process each row
            angular.forEach(csv.data, function (row) {

                survey = row[csv.meta.fields[0]].trim();
                category = row[csv.meta.fields[1]].trim();
                value = row[csv.meta.fields[2]].trim();

                if (survey === '' || category === '') {
                    return;
                }

                if (angular.isUndefined(out[survey])) {
                    out[survey] = [];
                }

                var dataRow = {
                    Category: category,
                    value: value,
                    AdditionalData: {
                        value: []
                    }
                };

                // Add optional additional data
                for (var i = 3; i < csv.meta.fields.length; i++) {
                    dataRow.AdditionalData.value.push(row[csv.meta.fields[i]].trim());
                }

                out[survey].push(dataRow);
            });

            return out;
        }

		function getFilterOptions() {
			return [
                {
                  label: 'December 2019',
                  value: 'December 2019'
                },
                {
                  label: 'November 2019',
                  value: 'November 2019'
                },
                {
                  label: 'October 2019',
                  value: 'October 2019'
                },
                {
                  label: 'September 2019',
                  value: 'September 2019'
                },
                {
                  label: 'August 2019',
                  value: 'August 2019'
                },
                {
                  label: 'July 2019',
                  value: 'July 2019'
                },
                {
                  label: 'June 2019',
                  value: 'June 2019'
                },
                {
                  label: 'May 2019',
                  value: 'May 2019'
                },
                {
                  label: 'April 2019',
                  value: 'April 2019'
                },
                {
                    label: 'March 2019',
                    value: 'March 2019'
                },
                {
                    label: 'February 2019',
                    value: 'February 2019'
                },
                {
                    label: 'January 2019',
                    value: 'January 2019'
                },
                {
                    label: 'December 2018',
                    value: 'December 2018'
                },
                {
                    label: 'November 2018',
                    value: 'November 2018'
                },
                {
                    label: 'October 2018',
                    value: 'October 2018'
                },
                {
                    label: 'September 2018',
                    value: 'September 2018'
                },
                {
                    label: 'August 2018',
                    value: 'August 2018'
                },
                {
                    label: 'July 2018',
                    value: 'July 2018'
                },
                {
                    label: 'June 2018',
                    value: 'June 2018'
                },
                {
                    label: 'May 2018',
                    value: 'May 2018'
                },
                {
                    label: 'April 2018',
                    value: 'April 2018'
                },
                {
                    label: 'March 2018',
                    value: 'March 2018'
                },
                {
                    label: 'February 2018',
                    value: 'February 2018'
                },
                {
                    label: 'January 2018',
                    value: 'January 2018'
                },
                {
                    label: 'December 2017',
                    value: 'December 2017'
                },
                {
                    label: 'November 2017',
                    value: 'November 2017'
                }
            ];
		}

		function getSamplesString(masterData, filter) {

			if (masterData.meta && masterData.meta.samples.length) {
				if (angular.isDefined(masterData.meta.sample_type)) {
					if (masterData.meta.sample_type === 'Single') {
						var base = 'Base: ' + (angular.isDefined(masterData.meta.sample_desc) ? masterData.meta.sample_desc + ', ' : '') + filter + (masterData.meta.filters.length == 1 ? ' ONLY' : '');
						var size =  masterData.meta.samples[filter];
						if (size !== undefined && size !== null) {
							if (isNaN(size)) {
								return base + ' ' + size;
							} else {
								return base + ' (n=' + size + ')';
							}
						}
						return base;
					} else if (masterData.meta.sample_type === 'Series') {
						var samples = [];
						angular.forEach(masterData.meta.series, function(series){
							var size =  masterData.meta.samples[series].sizes[filter];
							samples.push(masterData.meta.sample_desc[series] + ', ' + filter + (isNaN(size) ? ' ' + size : ' (n=' + size + ')'));
						});
						return 'Base: ' + samples.join('; ');
					} else {
						return 'Base: ' + (angular.isDefined(masterData.meta.sample_desc) ? masterData.meta.sample_desc + ', ' : '') + filter + (masterData.meta.filters.length == 1 ? ' ONLY' : '');
					}
				} else {
					var samples = [];

					angular.forEach(masterData.meta.samples, function(sample){
						if (angular.isDefined(filter) && filter != null) {
							if (isNaN(sample.sizes[filter])) {
								samples.push(sample.desc + ', ' + filter + ' ' + sample.sizes[filter]);
							} else {
								samples.push(sample.desc + ', ' + filter + ' (n=' + sample.sizes[filter] + ')');
							}
						}
					});

					if (samples.length == 0) return null;

					var identicalSamples = true;
					for (var i = 1; i < samples.length; i++) {
						if (samples[i] != samples[i-1]) {
							identicalSamples = false;
							break;
						}
					}

					return 'Base: ' + (identicalSamples ? samples[0] : samples.join('; '));
				}
			}

			return null;
		}

		function hasLowSampleSize(masterData, filter) {
			var result = false;
			var threshold = 100;
			if (masterData.meta && masterData.meta.samples) {
				if (angular.isDefined(masterData.meta.sample_type)) {
					if (masterData.meta.sample_type === 'Single') {
						var size =  masterData.meta.samples[filter];
						if (size != undefined && size != null) {
							if (!isNaN(size) && size < threshold) {
								result = true;
							}
						}
					} else if (masterData.meta.sample_type === 'Series') {
						angular.forEach(masterData.meta.series, function(series){
							var size =  masterData.meta.samples[series].sizes[filter];
							if (!isNaN(size) && size < threshold) {
								result = true;
							}
						});
					} else if (masterData.meta.sample_type === 'Category') {
						angular.forEach(masterData.meta.categories, function(category){
							var size =  masterData.meta.samples[category].sizes[filter];
							if (!isNaN(size) && size < threshold) {
								result = true;
							}
						});
					}
				} else {
					angular.forEach(masterData.meta.samples, function(sample){
						if (angular.isDefined(filter) && filter != null) {
							var size = sample.sizes[filter];
							if (!isNaN(size) && size < threshold) {
								result = true;
							}
						}
					});
				}
			}

			return result;
		}

		function generateSampleChartData(seriesNames, categoryNames) {
			var filterOptions = getFilterOptions();
			var data = {};
			angular.forEach(filterOptions, function(option){
				var itemArray = [];
				data[option.value] = itemArray;
				for(var catIdx = 0; catIdx < categoryNames.length; catIdx++) {
					var item = { Category: categoryNames[catIdx] };
					itemArray.push(item);
					for (var seriesIdx = 0; seriesIdx < seriesNames.length; seriesIdx++) {
						item[seriesNames[seriesIdx]] = Math.floor(Math.random() * 20) + 20;
					}
				}
			});

			return data;
		}

		function injectSampleInfo(masterData) {
			if (angular.isDefined(masterData.meta.sample_type)) {
				if (masterData.meta.sample_type === 'Category') {
					angular.forEach(masterData.data, function(values, filter){
						angular.forEach(values, function(item){
							var size = masterData.meta.samples[item.Category].sizes[filter];
							if (size != undefined && !isNaN(size)) {
								item.Category = item.Category + ' (n=' + size + ')';
							}
						});
					});
				}
			}
		}
    }
})();